import axios from 'axios'
import { iServerResponse, iValidationErrorResponse } from '@/types/api'
import { CredentialsException, ErrorException, ValidationException } from '@/utils/exceptions'
import store from '@/store'

const config = {
  baseURL: 'https://erp3.podorojnik.ru/external-cash/',
  rejectUnauthorized: false,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
}

export const instanceConfig = {
  ...config,
  transformResponse: [(data: string) => {
    const response = JSON.parse(data) as iServerResponse

    if (response.status === 401) {
      store.logout()
      throw new CredentialsException()
    }
    if (response.status >= 200 && response.status <= 299) {
      return response.data
    }
    if (response.status === 422) {
      throw new ValidationException(<iValidationErrorResponse> response.data)
    }
    throw new ErrorException(<string> response.data, response.status)
  }]
}

export default axios.create(instanceConfig)
